import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { useTypedSelector } from '../../combineReducers';

type Props = {
  path: string;
};

export const RouteRedirect: React.FC<Props> = ({ path }) => {
  const { userInfo } = useTypedSelector(state => state.userInfo);
  const organizationId = userInfo?.primaryOrganizationId;

  if (organizationId) {
    return <Redirect to={`/${organizationId}${path}`} />;
  }

  return null;
};
